// src/components/Sidebar.js
import React from 'react';

export default function Sidebar({ rfcs = [], onSelect, numericWithoutZeros = false }) {
    // rfcs is expected to be an array of objects with shape: { data: { id, title, author } }
    return (
        <aside style={{ width: '100%', padding: 12, overflowY: 'auto', boxSizing: 'border-box' }}>
            {Array.isArray(rfcs) && rfcs.length > 0 ? (
                rfcs.map(rfc => {
                    const id = rfc?.data?.id ?? 'Unknown';
                    const title = rfc?.data?.title || 'Untitled';
                    const author = Array.isArray(rfc?.data?.authors)
                        ? rfc.data.authors.join(', ')
                        : (rfc?.data?.author || '');

                    // Optionally show numeric id without leading zeros (e.g., "6" instead of "RFC0006")
                    const displayId = numericWithoutZeros
                        ? String(parseInt(id.replace(/^RFC/i, ''), 10))
                        : id;

                    return (
                        <div
                            key={id}
                            style={{ cursor: 'pointer', marginBottom: 12, padding: 8, borderRadius: 6 }}
                            onClick={() => {
                                console.log('sidebar clicked:', rfc);
                                onSelect?.(rfc);
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onSelect?.(rfc);
                                }
                            }}
                        >
                            <div style={{ fontWeight: 600, lineHeight: 1.4, wordBreak: 'break-word' }}>
                                {displayId} — {title}
                            </div>
                            {author && (
                                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                                    {author}
                                </div>
                            )}
                        </div>
                    );
                })
            ) : (
                <div style={{ color: '#666' }}>No RFCs available</div>
            )}
        </aside>
    );
}
